import { useState, useEffect } from "react"
import { CommunityLayout } from "../components/layout/Community"
import { useNavigate } from "react-router-dom"
import { CommunityFilters } from "../components/comm/CommunityFilters"
import { CommunityCard } from "../components/comm/CommunityCard"
import { getCommunities } from "../api/communities"

// Categories with improved naming and organization
const categories = [
  { id: "all", name: "All Categories" },
  { id: "technology", name: "Technology", color: "bg-blue-100  text-blue-800 " },
  { id: "business", name: "Business", color: "bg-yellow-100  text-yellow-800 " },
  { id: "health", name: "Health", color: "bg-green-100  text-green-800 " },
  { id: "science", name: "Science", color: "bg-purple-100  text-purple-800 " },
  { id: "education", name: "Education", color: "bg-red-100  text-red-800 " },
  { id: "entertainment", name: "Entertainment", color: "bg-pink-100  text-pink-800 " },
  { id: "sports", name: "Sports", color: "bg-orange-100  text-orange-800 " },
  { id: "gaming", name: "Gaming", color: "bg-indigo-100  text-indigo-800 " },
  { id: "arts", name: "Arts", color: "bg-rose-100  text-rose-800 " },
  { id: "food", name: "Food", color: "bg-amber-100  text-amber-800 " },
  { id: "travel", name: "Travel", color: "bg-cyan-100  text-cyan-800 " },
  { id: "finance", name: "Finance", color: "bg-emerald-100  text-emerald-800 " },
  { id: "fashion", name: "Fashion", color: "bg-fuchsia-100  text-fuchsia-800 " },
  { id: "photography", name: "Photography", color: "bg-violet-100  text-violet-800 " },
  { id: "music", name: "Music", color: "bg-lime-100  text-lime-800 " },
  { id: "other", name: "Other", color: "bg-gray-100  text-gray-800 " }
]

const sortOptions = [
  { value: '-createdAt', name: 'Newest' },
  { value: 'createdAt', name: 'Oldest' },
  { value: '-memberCount', name: 'Most popular' },
  { value: 'name', name: 'Name (A-Z)' },
  { value: '-name', name: 'Name (Z-A)' },
];


export function DiscoverPage() {
  const [selectedCategory, setSelectedCategory] = useState("all")
  const [searchQuery, setSearchQuery] = useState("")
  const [sortBy, setSortBy] = useState("popular")
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 12,
    pages: 1,
    total: 0,
  });
  const [filteredCommunities, setFilteredCommunities] = useState(communities)
  const navigateTo = useNavigate();
  const [filters, setFilters] = useState({});

  // Filter and sort communities based on selected category, search query, and sort option
  // useEffect(() => {
  //   let result = [...communities]

  //   // Apply category filter
  //   if (selectedCategory !== "all") {
  //     result = result.filter((community) => community.category.toLowerCase() === selectedCategory.toLowerCase())
  //   }

  //   // Apply search filter
  //   if (searchQuery) {
  //     const query = searchQuery.toLowerCase()
  //     result = result.filter(
  //       (community) =>
  //         community.name.toLowerCase().includes(query) || community.description.toLowerCase().includes(query),
  //     )
  //   }

  //   // Apply sorting
  //   switch (sortBy) {
  //     case "popular":
  //       result.sort((a, b) => b.members - a.members)
  //       break
  //     case "newest":
  //       // In a real app, you'd sort by creation date
  //       result.sort((a, b) => b.id - a.id)
  //       break
  //     case "active":
  //       result.sort((a, b) => b.posts - a.posts)
  //       break
  //     case "rating":
  //       result.sort((a, b) => b.rating - a.rating)
  //       break
  //   }

  //   setFilteredCommunities(result)
  // }, [selectedCategory, searchQuery, sortBy])

  // Fetch communities on mount and when filters or page changes
  useEffect(() => {
    fetchCommunities(pagination.page);
  }, [filters, pagination.page]);

  useEffect(() => {
    console.log("C :: ", communities)
    setFilteredCommunities(communities);
  }, [communities]);

  // Fetch communities
  const fetchCommunities = async (page = 1) => {
    try {
      setLoading(true);
      setError('');
      
      const queryParams = {
        page,
        limit: pagination.limit,
        ...filters,
      };
      
      const response = await getCommunities(queryParams);
      
      setCommunities(response.data.data.communities);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Error fetching communities:', error);
      setError('Failed to load communities. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  // Handle page change
  const handlePageChange = (page) => {
    setPagination((prev) => ({
      ...prev,
      page,
    }));
  };

  const handleCommunityClick = (communityId) => {
    navigateTo(`/communities/${communityId}`)
  }

  return (
    <CommunityLayout>
      {/* Hero Section with improved spacing */}
      <div className="relative rounded-xl overflow-hidden mb-10">
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 h-72 w-full">
          <div className="absolute inset-0 bg-pattern opacity-10"></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">Discover Communities</h1>
          <p className="text-lg sm:text-xl max-w-2xl mb-8 text-white/90">
            Find and join communities that match your interests and connect with like-minded people
          </p>
        </div>
      </div>

      {/* Filters with consistent spacing */}
      <div className="mb-10">
        <CommunityFilters
          categories={categories}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          sortOptions={sortOptions}
          selectedSort={sortBy}
          setSelectedSort={setSortBy}
          resultsCount={filteredCommunities.length}
        />
      </div>

      {/* Communities Grid with improved spacing */}
      {filteredCommunities.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {filteredCommunities.map((community) => (
            <CommunityCard key={community.id} {...community} community={community} onClick={() => handleCommunityClick(community.slug)} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-16 text-center bg-white  rounded-xl shadow-sm">
          <div className="w-24 h-24 bg-gray-100  rounded-full flex items-center justify-center mb-6">
            <svg className="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-3">No communities found</h3>
          <p className="text-gray-500  max-w-md mb-8">
            We couldn't find any communities matching your search criteria. Try adjusting your filters or search query.
          </p>
          <button
            onClick={() => {
              setSelectedCategory("all")
              setSearchQuery("")
              setSortBy("popular")
            }}
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Clear filters
          </button>
        </div>
      )}
    </CommunityLayout>
  )
}

